import {Component, Inject, OnInit} from '@angular/core';
import {CashbackGroup} from '../../../../dto/cashbackGroup';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-add-cashback-group-dialog',
  templateUrl: './add-cashback-group-dialog.component.html',
  styleUrls: ['./add-cashback-group-dialog.component.css']
})
export class AddCashbackGroupDialogComponent implements OnInit {

  public title = 'Create Cashback Group';
  public text = 'Please enter Group Code and Name';


  public code: string;
  public name: string;

  constructor(
    public dialogRef: MatDialogRef<AddCashbackGroupDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CashbackGroup
  ) { }

  ngOnInit() {

    if (this.data != null) {

    }
  }

  onYesClick(): void {

    const model = new CashbackGroup();
    model.code = this.code;
    model.name = this.name;


    this.dialogRef.close(model);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }


}
